import fetchHandler from './Handler';

const TOKEN_REFRESH_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const TOKEN_STORAGE_KEY = 'token';
const TOKEN_STORAGE_KEY_REFRESH = 'refresh';

let unauthorizedErrorCount = 0; // Counter for 401 errors

export const AuthenticationAPI = {
	tokenRefreshInterval: null as NodeJS.Timeout | null,

	async Login(data: any): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({ method: 'POST', endpoint: '/admin/login', data });
			if (response.isError) {
				return { isError: true, error: response.data };
			}
			localStorage.setItem(TOKEN_STORAGE_KEY, response.data.accessToken);
			localStorage.setItem(TOKEN_STORAGE_KEY_REFRESH, response.data.refreshToken);
			sessionStorage.setItem('username', response.adminname);
			sessionStorage.setItem('email', response.email);
			window.location.href = '/';

			this.startTokenRefreshInterval();

			return { isError: false, data: response };
		} catch (error) {
			console.error('Login error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},

	async SignUp(data: any): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({ method: 'POST', endpoint: '/users', data });
			if (response.isError) {
				return { isError: true, error: response.data };
			}

			localStorage.setItem(TOKEN_STORAGE_KEY, response.token);
			sessionStorage.setItem('username', response.adminname);
			sessionStorage.setItem('email', response.email);

			this.startTokenRefreshInterval();

			return { isError: false, data: response };
		} catch (error) {
			console.error('Sign up error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},

	Logout() {
		localStorage.removeItem(TOKEN_STORAGE_KEY);
		localStorage.removeItem(TOKEN_STORAGE_KEY_REFRESH);
		sessionStorage.clear();
		window.location.assign('/');

		if (this.tokenRefreshInterval) {
			clearInterval(this.tokenRefreshInterval);
		}
	},

	async ForgotPassword(
		email: string
	): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: '/forgot-password',
				data: { email },
			});
			if (response.isError) {
				return { isError: true, error: response.data };
			}

			return { isError: false, data: response };
		} catch (error) {
			console.error('Forgot password error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},

	async ResetPassword(data: any): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: '/reset-password',
				data,
			});
			if (response.isError) {
				return { isError: true, error: response.data };
			}

			return { isError: false, data: response };
		} catch (error) {
			console.error('Reset password error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},

	async refreshToken() {
		const refreshToken = localStorage.getItem(TOKEN_STORAGE_KEY_REFRESH);
		if (!refreshToken) {
			console.error('Refresh token not found');
			return;
		}

		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: 'admin/refresh',
				headers: {
					Authorization: `Bearer ${refreshToken}`,
				},
			});

			if (response.isError) {
				if (response.status === 401) {
					unauthorizedErrorCount++;
					if (unauthorizedErrorCount > 1) {
						this.Logout();
					}
				}
				console.error('Error refreshing token:', response.data);
				return;
			}

			unauthorizedErrorCount = 0; // Reset counter on successful response
			localStorage.setItem(TOKEN_STORAGE_KEY, response.data.accessToken);
			console.log('Token refreshed successfully');
		} catch (error) {
			console.error('Error refreshing token:', error);
		}
	},

	startTokenRefreshInterval() {
		if (this.tokenRefreshInterval) {
			clearInterval(this.tokenRefreshInterval);
		}
		this.tokenRefreshInterval = setInterval(() => {
			this.refreshToken();
		}, TOKEN_REFRESH_INTERVAL_MS);
	},
};
